<h6>Regulamin usługi</h6>
<mat-checkbox
    [formControl]="control"
    color="primary"
>
    <app-terms [serviceType]="ServiceType.RETAIL_MEDIA" />
</mat-checkbox>
